<template>
  <div class="pratical_title">
    <MainTitle
      :title="$t('pratical.praticalTitle')"
      :subtitle="$t('pratical.description')"
      background="title_blue"
    >
    </MainTitle>

    <!-- Filters the elements to avoid overloarding visuals -->
    <div
      class="pratical_btn_container"
      data-aos="fade"
      data-aos-duration="1000"
      data-aos-easing="ease-in-out"
      data-aos-once="true"
    >
      <button
        v-for="tab in tabs"
        :key="tab"
        @click="setActiveTab(tab)"
        :class="{ active: activeTab === tab }"
        class="pratical_btn"
      >
          {{ $t('pratical.tabs.' + tab) }}
      </button>
    </div>
    <!-- Dynamic content: Displays information about the outside area when the tab is activ  -->

    <div
      v-if="activeTab === 'restaurant'"
      class="section_container"
      data-aos="fade"
      data-aos-duration="1000"
      data-aos-easing="ease-in-out"
      data-aos-once="true"
    >
      <div
        v-for="(section, sectionIndex) in restaurants"
        :key="sectionIndex"
        class="section_item"
      >
        <img
          :src="icon_restaurant"
          :alt="$t('pratical.restaurantAlt')"
          class="section_img"
        />
        <div class="section_text">
          <h4 class="section_text_police">{{ section.title }}</h4>
          <div>{{ section.distance }}  </div>
          <a
            class="section_btn"
            :href="getGoogleMapsLink(section.address)"
            target="_blank"
          >
            {{$t('pratical.map')}}
          </a>
        
        </div>
      </div>
    </div>
    <div
      v-if="activeTab === 'shop'"
      class="section_container"
      data-aos="fade"
      data-aos-duration="1000"
      data-aos-easing="ease-in-out"
      data-aos-once="true"
    >
      <div
        v-for="(section, sectionIndex) in shops"
        :key="sectionIndex"
        class="section_item"
      >
        <img :src="icon_shop" :alt="$t('pratical.shopAlt')" class="section_img" />
        <div class="section_text">
          <h4 class="section_text_police">{{ section.title }}</h4>
          <div>{{ section.distance }}</div>
           <a
            class="section_btn"
            :href=section.address
            target="_blank"
          >
            {{$t('pratical.button')}}
          </a>
          
        </div>
      </div>
    </div>
  </div>
  <div
    v-if="activeTab === 'wastemanagement'"
    class="section_container_2"
    data-aos="fade"
    data-aos-duration="1000"
    data-aos-easing="ease-in-out"
    data-aos-once="true"
  >
    <h3>{{ $t('pratical.waste.title') }}</h3>
<ul>
  <li v-for="(item, index) in wasteInstructions" :key="index">
    {{ item }}
  </li>
</ul>
  </div>

  <div
      v-if="activeTab === 'ideas'"
      class="section_container_2"
      data-aos="fade"
      data-aos-duration="1000"
      data-aos-easing="ease-in-out"
      data-aos-once="true"
    >
      <div
        v-for="(section, sectionIndex) in ideas"
        :key="sectionIndex"
        class="section_item"
      >
        <div class="section_text">
          <h4 class="section_text_police">{{ section.title }}</h4>
          <div>{{ section.description }}  </div>   
        </div>
      </div>
    </div>

  <div
    v-if="activeTab === 'contact'"
    class="section_container_2"
    data-aos="fade"
    data-aos-duration="1000"
    data-aos-easing="ease-in-out"
    data-aos-once="true"
  >
    <h3>{{ $t('pratical.contact.title') }}</h3>
    <div>
       {{ $t('pratical.contact.owner') }}
      <ul>
        <li>Clarisse + 33 06 87 15 53 44</li>
        <li>Raymonde + 41 78 804 32 41</li>
      </ul>
    </div>
    <div>{{ $t('pratical.contact.emergency') }}
    <ul>
      <li>{{ $t('pratical.contact.pompier') }}</li>
      <li>{{ $t('pratical.contact.samu') }}</li>
      <li>{{ $t('pratical.contact.police') }}</li>
      <li>{{ $t('pratical.contact.ue') }}</li>
      <li>{{ $t('pratical.contact.antipoison') }}</li>
      <li>{{ $t('pratical.contact.medecin') }}</li>
    </ul>
  </div>
    <div>{{ $t('pratical.contact.medical') }}
    <ul>
      <li>{{ $t('pratical.contact.phama') }}</li>
      <li>
        {{ $t('pratical.contact.cabinet') }}
      </li>
      <li>{{ $t('pratical.contact.hospital') }}</li>
    </ul>
  </div>
    <div>{{ $t('pratical.contact.advice') }}
    <ul>
      <li>
        {{ $t('pratical.contact.advice1') }}
      </li>
      <li>
       {{ $t('pratical.contact.advice2') }}
      </li>
    </ul>
  </div>
  </div>
</template>

<script>
import MainTitle from "@/components/MainTitle.vue";
import { useI18n } from 'vue-i18n';
import { ref, computed } from 'vue';
import fr from "@/locales/fr.json";
import en from "@/locales/en.json";
import de from "@/locales/de.json";

export default {
  name: "PraticalInformationsView",
  components: {
    MainTitle,
  },

   setup() {
      const { locale } = useI18n();
  const activeTab = ref('ideas');
    const tabs = ['ideas', 'restaurant', 'shop', 'wastemanagement', 'contact' ];
const restaurants = computed(() => {
  const map = {
    fr: fr.pratical.restaurants,
    en: en.pratical.restaurants,
    de: de.pratical.restaurants
  };
  return map[locale.value] || fr.pratical.restaurants;
});

const shops = computed(() => {
  const map = {
    fr: fr.pratical.shops,
    en: en.pratical.shops,
    de: de.pratical.shops
  };
  return map[locale.value] || fr.pratical.shops;
});

const ideas = computed(() => {
  const map = {
    fr: fr.pratical.ideas,
    en: en.pratical.ideas,
    de: de.pratical.ideas
  };
  return map[locale.value] || fr.pratical.ideas;
});

const wasteInstructions = computed(() => {
  const map = {
    fr: fr.pratical.waste.instructions,
    en: en.pratical.waste.instructions,
    de: de.pratical.waste.instructions
  };
  return map[locale.value] || fr.pratical.waste.instructions;
});

  const setActiveTab = (tab) => {
      activeTab.value = tab;
    };
 const getGoogleMapsLink = (address) => {
      return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
    };

    return {
      
      activeTab,
      tabs,
      restaurants,
      shops,
      ideas,
      wasteInstructions,
      setActiveTab,
      getGoogleMapsLink
    };
  },
   
  data() {
    return {
      icon_restaurant: require("../assets/icons/restaurants/food.png"),
    
      icon_shop: require("../assets/images/market.jpg"),

  }
}
}
</script>

<style lang="scss">
@import "../assets/styles/_variables.scss";

.pratical_title {
  max-width: 75%;
  margin: $spacing-extralarge auto;
}
.pratical_btn {
  margin-right: 1rem;
  background-color: white;
}
.section_text_police {
    font-size: 1.3rem;
  }
.section_container {
  margin: $spacing-extralarge auto;
  display: flex;
  flex-direction: column;

  gap: $spacing-large;
}
.section_container_2 {
  margin: $spacing-extralarge auto;
  max-width: 75%;
  display: flex;
  flex-direction: column;
  gap: $spacing-large;
}
.section_item {
  display: flex;
  align-items: flex-start;
  gap: $spacing-large;
}
.section_text {
  flex: 1;
}

.section_img {
  max-width: 10%;
}
.section_btn {
  gap: 1rem;
}

@media (max-width: 48rem) {
  .section_container {
    width: 90%;
  }
  .section_container_2 {
    width: 90%;
  }

  .section_text_police {
    font-size: 1.1rem;
  }
  .pratical_btn_container {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
}
</style>
